import React from "react";

import { getApiErrorMessage, useToaster } from "utils";
import { PaziaModal } from "components/molecules";
import { coursetranchesApi } from "api";

import { CourseTrancheApi } from "api/types";
import { CreateTrancheForm, TrancheFromValues } from "pages/CourseCreate/Payment/CreateTrancheForm";
import { queryClient } from "main";
import { QUERIES_KEYS } from "queries";
import { ModalHeader } from "../Modals/ModalHeader";

interface EditTrancheModalProps {
  onCloseRequest: () => Promise<void>;
  courseId: number;
  dateOfCourse: Date;
  tranche?: CourseTrancheApi;
}

export const EditTrancheModal = ({ onCloseRequest, courseId, dateOfCourse, tranche }: EditTrancheModalProps) => {
  const { showSuccess, showError } = useToaster();

  const onSubmit = async (formData: TrancheFromValues) => {
    if (!tranche) return;
    try {
      await coursetranchesApi.update(courseId, tranche.id, formData);
      showSuccess("Transza została zaktualizowana.");
      queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.COURSE_TRANCHES(courseId!) });
      onCloseRequest();
    } catch (error) {
      showError(getApiErrorMessage(error, "Nie udało się edytować transzy."));
    }
  };

  return (
    <PaziaModal
      id="edit-tranche-modal"
      onCloseRequest={onCloseRequest}
      isOpen={tranche != null}
      size="xl"
      className="p-4"
    >
      <ModalHeader>Edytuj transzę płatności</ModalHeader>
      {tranche && <CreateTrancheForm onSubmit={onSubmit} dateOfCourse={dateOfCourse} tranche={tranche} />}
    </PaziaModal>
  );
};
